import React, { Fragment, useEffect, useContext } from 'react';
import TreeContainer from './TreeContainer';
import GraphGrid from './GraphGrid';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ViewContext } from '../../context/view/ViewContext';
import GaugeContext from '../../context/gauge/gaugeContext';

export const Dashboard = () => {
	const gaugeContext = useContext(GaugeContext);
	const { fetchNodes } = gaugeContext;

	useEffect(() => {
		fetchNodes();
	}, []);

	return (
		<ViewContext.Consumer>

			{({ views }) => (
				<>
					<Fragment>
						<Row className="row-fix">
							<Col>{views.clusterHierarchy ? <TreeContainer /> : null}</Col>
						</Row>

						<Row className="chart-box row-fix">
							<Col className="row-fix">
								<GraphGrid />
							</Col>
						</Row>
						
					</Fragment>
				</>
			)}
		</ViewContext.Consumer>
	);
};

export default Dashboard;
